import { useContext, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import FileDisplay from '../../utils/FileDisplay';
import CTS_Footer from './CTS_Footer';
import XYZLABS_Footer from './XYZLABS_Footer';
import LabIDContext from '../../store/LabIDContext';
import VersionDisplay from './VersionDisplay';
import FooterClasses from './AppFooter.module.css';

const AppFooter = () => {
  const labid = useContext(LabIDContext);
  const [footerImageExists, setFooterImageExists] = useState(false);

  useEffect(() => {
    const checkImage = async () => {
      try {
        const response = await fetch(`/images/${labid}_Footer.jpg`, {
          method: 'GET',
        });
        const contentType = response.headers.get("content-type") || "";
        const exists = response.ok && contentType.includes("image");
        setFooterImageExists(exists);
      } catch (error) {
        console.warn(`Footer image check failed for lab ${labid}`, error);
        setFooterImageExists(false);
      }
    };

    if (labid) {
      checkImage();
    }
  }, [labid]);

  return (
    <footer className={FooterClasses.appFooter}>
      <div className={FooterClasses.buttonArea}>
        <div className={FooterClasses.fileContainer}>
          {/* Load optional dynamic JS component */}
          <FileDisplay filePath={`${labid}_Footer.js`} />

          <div
            className={FooterClasses.fileContainer2}
            style={{
              flexDirection: footerImageExists ? 'row' : 'column',
              justifyContent: footerImageExists ? 'space-between' : 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            {footerImageExists && (
              <div className={FooterClasses.left}>
                <img
                  src={`/images/${labid}_Footer.jpg`}
                  alt={`${labid} Footer`}
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </div>
            )}

            <div className={FooterClasses.navAreaText}>
              <NavLink to='systemMsg' className={FooterClasses.navAreaText}>
                Terms Of Service
              </NavLink>
            </div>

            <div
              className={FooterClasses.rightGroup}
              style={{
                marginTop: footerImageExists ? '0' : '10px',
              }}
            >
              <img className={FooterClasses.powImg} src='/images/powimage.gif' alt='' />
              <VersionDisplay />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
